var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 80,
    viewBox: "0 0 74 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.4364 80H11.5273C5.52727 80 0.618179 75.0909 0.618179 69.0909V29.0909C0.618179 27.9636 1.12727 26.9091 2.03636 26.2182L34.7636 0.763636C36.0727 -0.254545 37.9273 -0.254545 39.2364 0.763636L71.9636 26.2182C72.8364 26.9091 73.3818 27.9636 73.3818 29.0909V69.0909C73.3818 75.0909 68.4727 80 62.4727 80H62.4364ZM7.89091 30.8727V69.0909C7.89091 71.0909 9.52727 72.7273 11.5273 72.7273H62.4364C64.4364 72.7273 66.0727 71.0909 66.0727 69.0909V30.8727L36.9818 8.25455L7.89091 30.8727Z",
    fill: "#8ACB23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.c0b33e0856964b0ba9dba213412831be.svg";
export { ForwardRef as ReactComponent };